module.exports = __webpack_public_path__ + "img/blue-logo.b65f71d3.svg";